import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { ListDropdown } from '@components/library/dropdown/index';
import { assetStatusOptions } from '@components/show_page/sections/section_search/helper';
import SectionsContext from '../sectionsContext';
import TagsFilter from './tagsFilter';
import FiletypesFilter from './filetypesFilter';
import CustomfieldsFilter from './customfieldsFilter';
import OrientationFilter from './orientationFilter';
import CommentsFilter from './commentsFilter';
import SkuFilter from './skuFilter';
import DateFilter from './dateFilter';

import './styles/main.scss';

const AdvancedFiltersDrawer = ({
  filters,
  filtersDrawerOpen,
  tagsSearchOperator,
  searchableThings,
  selectedAssetKeys,
  toggleFiltersDrawer,
  updateFilters,
  updateTagsSearchOperator,
  refresh,
}) => {
  const advancedFiltersContainerRef = useRef(null);

  return (
    <SectionsContext.Consumer>
      {({ editable }) => (filtersDrawerOpen === "advanced-filters" && (
        <>
          <div className="header-filter-section">
            <div className="flex-row">
              <h3 className="filter-title">{t('Advanced Filters')}</h3>
              <div className="header-buttons">
                <button
                  className="refresh-button bff-refresh"
                  onClick={refresh}
                  type="button"
                />
                <button
                  className="clear-button"
                  onClick={() => updateFilters("reset")}
                  type="button"
                >
                  <span>{t('Reset')}</span>
                </button>
                <button
                  className="close-button"
                  onClick={() => toggleFiltersDrawer('advanced-filters')}
                  type="button"
                >
                  <span className="bff-close" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
          <div
            className={`container bf-scroll-element ${selectedAssetKeys.size ? 'select-bar-active' : ''}`}
            ref={advancedFiltersContainerRef}
          >
            <form className="search-filter-form">
              {editable && (
                <div className="filter-section status cx-filters-status">
                  <div className="flex-row title">
                    <p>{t('Asset Status')}</p>
                  </div>
                  <div className="status__container">
                    <ListDropdown
                      className="status__dropdown"
                      onChange={(option) => updateFilters('availability', option?.value || null)}
                      options={assetStatusOptions}
                      overflowParentRef={advancedFiltersContainerRef}
                      placeholder={t("Select status")}
                      value={filters.availability}
                    />
                  </div>
                </div>
              )}
              <TagsFilter
                tagsSearchOperator={tagsSearchOperator}
                searchableThings={searchableThings}
                tags={filters.tags}
                updateFilters={(value) => updateFilters("tags", value)}
                updateTagsSearchOperator={updateTagsSearchOperator}
              />
              <FiletypesFilter
                filetypes={filters.filetypes}
                searchableThings={searchableThings}
                updateFilters={(value) => updateFilters("filetypes", value)}
              />
              <CustomfieldsFilter
                advancedFiltersContainerRef={advancedFiltersContainerRef}
                customFields={filters.custom_fields}
                removeFilters={(key, value) => updateFilters("remove_custom_field", key, value)}
                searchableThings={searchableThings}
                updateFilters={(key, value) => updateFilters("custom_fields", key, value)}
              />
              <OrientationFilter
                orientation={filters.orientation}
                updateFilters={(value) => updateFilters("orientation", value)}
              />
              {BFG.context.hasFeature("comments") && editable && (
                <CommentsFilter
                  updateFilters={(value) => updateFilters("comments", value)}
                  checked={Boolean(filters.comments)}
                />
              )}
              <SkuFilter updateFilters={(value) => updateFilters("sku", value)} />
              <DateFilter
                createdDate={filters.created_at}
                updateFilters={(value) => updateFilters("created_at", value)}
              />
            </form>
          </div>
        </>
      ))}
    </SectionsContext.Consumer>
  );
};

AdvancedFiltersDrawer.propTypes = {
  filters: PropTypes.shape({}).isRequired,
  filtersDrawerOpen: PropTypes.oneOf(['labels', 'advanced-filters', 'none']).isRequired,
  tagsSearchOperator: PropTypes.string.isRequired,
  searchableThings: PropTypes.shape({}).isRequired,
  selectedAssetKeys: PropTypes.instanceOf(Set).isRequired,
  toggleFiltersDrawer: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  updateTagsSearchOperator: PropTypes.func.isRequired,
  refresh: PropTypes.func,
};

AdvancedFiltersDrawer.defaultProps = {
  refresh: () => {},
};

export default AdvancedFiltersDrawer;
